import { VideoPlayerActionContext } from '../types';

type Ctx = VideoPlayerActionContext;

const DEFAULT_HIDE_TIMEOUT = 4500;
const TIMEOUT_MULTIPLIER = {
  Immediate: 0.1,
  Quick: 0.5,
  Base: 1,
  Long: 4,
};
export type TimeoutMultiplier = keyof typeof TIMEOUT_MULTIPLIER;

const getDuration = (option: PlayerControlCommitShowPayload['autoHide']): number => {
  if (option == null || option === true) {
    return DEFAULT_HIDE_TIMEOUT;
  }

  if (option === false) {
    return Infinity;
  }

  if (option in TIMEOUT_MULTIPLIER) {
    return TIMEOUT_MULTIPLIER[option] * DEFAULT_HIDE_TIMEOUT;
  }

  throw new Error('The provided key is not a member of TIMEOUT_MULTIPLIER');
};

export type PlayerControlCommitPayload = PlayerControlCommitShowPayload | PlayerControlCommitHidePayload;
export interface PlayerControlCommitShowPayload {
  type: 'show';
  /**
   * Configure autoHide behaviour by providing a TimeoutMultiplier
   *
   * If the provided value is a bollean `true`, a nullish or is not provided,
   * then the default timeout will be used instead.
   *
   * If the provided value is a boolean `false`, autoHide behaviour will not be enabled
   */
  autoHide?: TimeoutMultiplier | boolean;
}

export interface PlayerControlCommitHidePayload {
  type: 'hide';
}

const resetHideHandler = ({ state, commit }: Ctx): void => {
  const { controlBarResetHandle } = state.controls.visibility;
  if (controlBarResetHandle !== null) {
    clearTimeout(controlBarResetHandle);
  };

  commit('setControl', ['controlBarResetHandle', null]);
};
const handleRequestToHide = (context: Ctx): void => {
  const { commit } = context;

  resetHideHandler(context);
  commit('setControl', ['controlBar', false]);
};
const handleRequestToShow = (context: Ctx, autoHide?: PlayerControlCommitShowPayload['autoHide']): void => {
  const { dispatch, commit } = context;

  resetHideHandler(context);

  const duration = getDuration(autoHide);

  commit('setControl', ['controlBar', true]);

  if (!Number.isFinite(duration)) return;

  commit('setControl', ['controlBarResetHandle',
    setTimeout(() => {
      dispatch('setPlayerControl', {
        type: 'hide',
      });
    }, duration),
  ]);
};

export const setPlayerControl = (context: Ctx, payload: PlayerControlCommitPayload): void => {
  if (payload.type === 'show') {
    handleRequestToShow(context, payload.autoHide);
  }
  if (payload.type === 'hide') {
    handleRequestToHide(context);
  }
};
